import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CreditCard, Loader2 } from "lucide-react";
import { SaudiRiyal } from "../components/SaudiRiyal";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PayCheckout() {
  const [amount, setAmount] = useState("100");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [desc, setDesc] = useState("دفعة WorkZone");
  const [busy, setBusy] = useState(false);

  const pay = async () => {
    const amt = parseFloat(amount);
    if (!amt || amt <= 0) { toast.error("أدخل مبلغًا صحيحًا"); return; }
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/payments/create`, {
        amount: amt, description: desc, name: name || "Customer",
        email: email || "customer@example.com", phone: phone || "0500000000",
      });
      window.location.assign(data.checkout_url);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "تعذّر بدء الدفع");
      setBusy(false);
    }
  };

  return (
    <div dir="rtl" className="min-h-screen bg-slate-50 flex items-center justify-center p-4 font-body" data-testid="pay-checkout">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 shadow-sm space-y-4">
        <div className="flex items-center gap-2 font-heading text-xl font-bold text-slate-900">
          <CreditCard className="h-6 w-6 text-blue-600" /> الدفع الإلكتروني
        </div>
        <div className="space-y-1.5">
          <Label>المبلغ (<SaudiRiyal />)</Label>
          <Input data-testid="pay-amount" type="number" dir="ltr" value={amount} onChange={(e) => setAmount(e.target.value)} className="font-mono-nums" />
        </div>
        <div className="space-y-1.5">
          <Label>الوصف</Label>
          <Input data-testid="pay-desc" value={desc} onChange={(e) => setDesc(e.target.value)} />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1.5"><Label>الاسم</Label><Input data-testid="pay-name" value={name} onChange={(e) => setName(e.target.value)} /></div>
          <div className="space-y-1.5"><Label>الجوال</Label><Input data-testid="pay-phone" dir="ltr" value={phone} onChange={(e) => setPhone(e.target.value)} /></div>
        </div>
        <div className="space-y-1.5"><Label>البريد الإلكتروني</Label><Input data-testid="pay-email" dir="ltr" value={email} onChange={(e) => setEmail(e.target.value)} /></div>
        <Button data-testid="pay-submit" disabled={busy} onClick={pay} className="w-full h-11 bg-blue-600 hover:bg-blue-700 gap-1.5">
          {busy ? <><Loader2 className="h-4 w-4 animate-spin" /> جارٍ فتح الدفع…</> : <>ادفع بأمان عبر Paymob</>}
        </Button>
        <p className="text-[11px] text-slate-400 text-center">مدعوم بـ Paymob — بطاقات / مدى / Apple Pay (حسب تفعيل حسابك)</p>
      </div>
    </div>
  );
}
